import { render, staticRenderFns } from "./GLPMedicationOption.vue?vue&type=template&id=28999d94&scoped=true"
import script from "./GLPMedicationOption.vue?vue&type=script&lang=js"
export * from "./GLPMedicationOption.vue?vue&type=script&lang=js"
import style0 from "./GLPMedicationOption.vue?vue&type=style&index=0&id=28999d94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28999d94",
  null
  
)

export default component.exports